import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'v8te-button',
  templateUrl: 'v8te-button.component.html',
  styleUrls: ['./v8te-button.component.less', './../../common.less'],
})

export class V8teButtonComponent implements OnInit {
  @Input() buttonText: string = "Valider";
  @Input() minHeight: number = 40;
  @Input() height: number = 67;
  @Input() minWidth: number = 284;
  @Input() width: number = 284;
  @Input() bgColor: string = "white";
  @Input() bgColorHover: string = "#1990FF";
  @Input() textColor: string = "#1990FF";
  @Input() textColorHover: string = "white";
  @Input() border: string = "solid 1px #1990FF";
  @Input() borderHover: string = "solid 1px #1990FF";
  @Input() radius: number = 10;
  @Input() padding: string = "0px 20px 0px 20px";
  @Input() icon: string = "";
  @Input() iconHover: string = "";
  @Input() iconAlt: string = "";
  @Input() iconPosition: "left" | "right" = "left"; 

  @Input() buttonPlus: boolean = false;
  @Input() customWidthPx: number;
  @Input() customWidthPercent: number;
  @Output() createPollEvent = new EventEmitter<boolean>();

  currentBgColor: string;
  currentTextColor: string;
  currentBorder: string;
  currentIcon: string;

  ngOnInit() {
    this.currentBgColor = this.bgColor;
    this.currentTextColor = this.textColor;
    this.currentBorder = this.border;
    this.currentIcon = this.icon;
  }

  onMouseEnter() {
    if (this.bgColorHover) this.currentBgColor = this.bgColorHover;
    if (this.textColorHover) this.currentTextColor = this.textColorHover;
    if (this.borderHover) this.currentBorder = this.borderHover;
    if (this.iconHover) this.currentIcon = this.iconHover;
  }

  onMouseLeave() {
    this.currentBgColor = this.bgColor;
    this.currentTextColor = this.textColor;
    this.currentBorder = this.border;
    this.currentIcon = this.icon;
  }
}
